import React from "react";
import { FormattedMessage } from "react-intl";

import Tutorial from "../../../../Tutorial";

import messages from "./messages";
import { IProps } from "./interfaces";
import FormattedHtmlMessage from "../../../../../../common/helpers/FormattedHtmlMessage";

const BarlineTutorial = ({ close, title }: IProps) => (
    <Tutorial close={close} title={title}>
        {[
            {
                title: <FormattedMessage {...messages.title1} />,
                content: () => <FormattedHtmlMessage {...messages.description1} />,
            },
            {
                title: <FormattedMessage {...messages.title3} />,
                content: () => <FormattedHtmlMessage {...messages.description3} />,
            },
        ]}
    </Tutorial>
);

export default BarlineTutorial;
